import axios from 'axios'

export const api = axios.create({
  baseURL: 'https://api-prod.appgorgulho.com/api/v1/'
})
